import { Plural } from "@lingui/react/macro";
import React from "react";
import { useStats } from "./useStats";

export const PageStats = () => {
  const { nbHits } = useStats();
  return (
    <React.Fragment>
      <Plural
        value={nbHits}
        one="# Result"
        other="# Results"
        zero="No Results Found"
      />
    </React.Fragment>
  );
};
